import React, { useEffect, useState } from 'react';
import '../../components/sectorInsights/SectorInsights.scss';
import Input from '../input/Input';
import { MAX_TEXT_LENGTH } from '../../app.constant';
import { closeIcon, searchIcon } from '../../commonImage';

interface ISectorGeographyHierarchyFilterProps {
  placeholder: string;
  filter?: (text: string) => void;
  setInputFilter: boolean;
}

export const SectorGeographyHierarchyFilter = (props: ISectorGeographyHierarchyFilterProps) => {
  const [inputValue, setInputValue] = useState<string>('');
  const [filterTextPresent, setFilterTextPresent] = useState<boolean>(false);

  useEffect(() => {
    handleRemove();
  }, [props.setInputFilter]);
  const handleChange = (event: any) => {
    const inputValue: string = event.target.value;
    setInputValue(inputValue);
    if (inputValue && inputValue.length > 0) {
      setFilterTextPresent(true);
    } else {
      setFilterTextPresent(false);
    }
    props.filter && props.filter(inputValue);
  };

  const handleRemove = () => {
    if (inputValue.length > 0) {
      setInputValue('');
      props.filter && props.filter('');
      setFilterTextPresent(false);
    }
  };

  return (
    <div className='hierarchy-search-filter'>
      <Input
        value={inputValue}
        handleChange={handleChange}
        maxLength={MAX_TEXT_LENGTH}
        placeholder={props.placeholder}
        readOnly={false}
      />
      {filterTextPresent ? (
        <img onClick={handleRemove} className='se-close-icon' src={closeIcon} />
      ) : (
        <img className='fas fa-search' src={searchIcon} />
      )}
    </div>
  );
};

export default React.memo(SectorGeographyHierarchyFilter);
